import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/kcc/overrides");

export const Route = createFileRoute("/kcc/overrides")({
  head: () => ({
    meta: [
      { title: "KCC overrides — LevelLoad" },
      { name: "description", content: "KCC overrides — LevelLoad transport planning." },
      { property: "og:title", content: "KCC overrides — LevelLoad" },
      { property: "og:description", content: "KCC overrides — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
